import COS from 'cos-js-sdk-v5'
import request from './request'

// STS 临时密钥缓存
let cachedCredentials = null

const EXPIRE_AHEAD_MS = 2 * 60 * 1000

/**
 * 获取 STS 临时密钥，带模块级缓存
 */
async function getStsCredentials () {
  const now = Date.now()
  if (cachedCredentials && cachedCredentials.expiredTime * 1000 > now + EXPIRE_AHEAD_MS) {
    return cachedCredentials
  }
  const res = await request({
    url: '/tx-cloud-file/getPolicyTxCloudReportPack',
    method: 'post'
  })
  cachedCredentials = res.data
  return cachedCredentials
}

/**
 * 获取或创建 COS 实例（每次使用新密钥）
 */
async function getCosInstance () {
  const cred = await getStsCredentials()
  return {
    cos: new COS({
      getAuthorization: function (options, callback) {
        callback({
          TmpSecretId: cred.tmpSecretId,
          TmpSecretKey: cred.tmpSecretKey,
          SecurityToken: cred.sessionToken,
          StartTime: cred.startTime,
          ExpiredTime: cred.expiredTime
        })
      }
    }),
    cred
  }
}

function getFileExtension (name) {
  return String(name || '').split('.').pop().toLowerCase()
}

function getFileCategory (file) {
  const mime = (file && file.type) || ''
  const ext = getFileExtension(file && file.name)
  if (mime.startsWith('image/') || ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp'].includes(ext)) return 'image'
  if (mime.startsWith('video/') || ['mp4', 'avi', 'mov', 'wmv'].includes(ext)) return 'video'
  if (mime.startsWith('audio/') || ['mp3', 'wav', 'ogg'].includes(ext)) return 'audio'
  return 'document'
}

/**
 * 供 ajUpload 的 uploadRequest prop 使用
 * @param {File} rawFile - 用户选择的原始文件
 * @param {Object} context - { fileList }
 * @returns {Object} - 符合 ajUpload normalizeUploadedFile 的格式
 */
export async function uploadToCos (rawFile, { fileList }) {
  const { cos, cred } = await getCosInstance()

  const ext = getFileExtension(rawFile.name)
  const timestamp = Date.now()
  const random = Math.random().toString(36).slice(2, 8)
  const fileName = `${timestamp}_${random}.${ext}`
  const basePath = cred.filePath.endsWith('/') ? cred.filePath : cred.filePath + '/'
  const objectKey = basePath + fileName

  await new Promise((resolve, reject) => {
    cos.putObject({
      Bucket: cred.bucket,
      Region: cred.region,
      Key: objectKey,
      Body: rawFile,
      ContentLength: rawFile.size
    }, function (err, data) {
      if (err) {
        reject(new Error(err.message || 'COS上传失败'))
        return
      }
      resolve(data)
    })
  })

  const fileUrl = cred.baseHttp + objectKey

  return {
    data: {
      name: rawFile.name,
      url: fileUrl,
      size: rawFile.size,
      extension: ext,
      mime_type: rawFile.type,
      type: getFileCategory(rawFile),
      storageKey: objectKey
    }
  }
}

export default uploadToCos
